/*!
 * ms-outfit.js – "Vervollständige dein Outfit"
 * Massive Soldier | MG Commerce | Stand 10/2026
 *
 * Aufbau:
 *   1. CORE   – reine Funktionen (Titel-Parser, Scoring, Slot-Auswahl). Kein DOM. In Node testbar.
 *   2. FETCH  – Kandidaten über öffentliche Storefront-Endpunkte (kein API-Key, keine KI-API).
 *   3. UI     – Karten rendern, Größen-Sync, Add-to-Cart, Cart-Drawer-Refresh, Tracking.
 *
 * Wörterbücher bei neuen Produktarten/Farben in DICT ergänzen.
 */
(function (root) {
  'use strict';

  /* =========================================================================
   * 1. CORE
   * ======================================================================= */

  var DICT = {
    // Markenwörter: zählen nie zur Linie
    brand: ['MASSIVE', 'SOLDIER', 'MASSIVESOLDIER', 'SOLDIERS'],
    // Füllwörter: ignoriert
    filler: ['OVERSIZE', 'OVERSIZED', 'SLIM', 'X', 'BY', 'THE', 'A', 'AND', 'UND', 'MIT', 'PACK', '3ER', 'KOPIE',
      'EDITION', 'LIMIT', 'LIMITED', 'NEW', 'LANG', 'KURZ', 'NORMAL', 'RUNDHALS', 'WASHED', 'WASH'],
    // Schwache Linienwörter: zählen nur, wenn sonst keine Linie übrig bleibt
    weak: ['BASIC', 'LOGO', 'CLASSIC', 'OG', 'GYM', 'SPORT', 'SPORTS', 'LIFESTYLE', 'BIG', 'ATHLETE'],
    // Farben (inkl. Modifikatoren)
    colors: ['BLACK', 'SCHWARZ', 'WHITE', 'WEISS', 'RED', 'ROT', 'GREY', 'GRAY', 'GRAU', 'NAVY', 'OLIVE', 'MINT',
      'WEINROT', 'REDWINE', 'BURGUNDER', 'BEIGE', 'CREME', 'CREAM', 'CAMO', 'CAMOUFLAGE', 'ROSA', 'PINK', 'ORANGE',
      'BLUE', 'BLAU', 'LIGHTBLUE', 'BERRY', 'FLIEDER', 'BROWN', 'BRAUN', 'MAMOR', 'MARMOR', 'OCEAN', 'LILA',
      'PURPLE', 'PEACH', 'YELLOW', 'GELB', 'GREEN', 'GRUEN', 'TUERKIS', 'TURKIS', 'ROYAL', 'APRICOT', 'SAND',
      'KHAKI', 'TAUPE', 'ACID', 'DARK', 'LIGHT', 'PASTEL', 'SEA', 'STRIPE'],
    neutralColors: ['BLACK', 'SCHWARZ', 'WHITE', 'WEISS', 'GREY', 'GRAY', 'GRAU'],
    // Produkttyp -> Kategorie + Subtyp. Kurze Keys (<5) exakt, lange Keys auch als Wortende (Komposita).
    types: {
      TOP: { SHIRT: 'SHIRT', TSHIRT: 'SHIRT', TEE: 'SHIRT', TANK: 'TANK', STRINGER: 'TANK', TOP: 'TOP', POLO: 'POLO',
        POLOSHIRT: 'POLO', HEMD: 'HEMD', TRIKOT: 'JERSEY', JERSEY: 'JERSEY', LONGSLEEVE: 'LONGSLEEVE' },
      LAYER: { HOODIE: 'HOODIE', HOODY: 'HOODIE', ZIPPER: 'ZIPPER', SWEATER: 'SWEATER', FLEECE: 'SWEATER',
        CREWNECK: 'SWEATER', JACKET: 'JACKET', JACKE: 'JACKET', BOMBER: 'JACKET' },
      BOTTOM: { JOGGER: 'JOGGER', JOGGINGHOSE: 'JOGGER', PANTS: 'PANTS', TROUSERS: 'PANTS', HOSE: 'PANTS',
        SHORTS: 'SHORTS', SHORT: 'SHORTS', LEGGINGS: 'LEGGINGS', LEGGING: 'LEGGINGS' },
      WTOP: { BRA: 'BRA' },
      ONEPIECE: { JUMPSUIT: 'JUMPSUIT', BODYSUIT: 'BODYSUIT' },
      FOOT: { SOCKEN: 'SOCKS', SOCKS: 'SOCKS', BADELATSCHEN: 'SLIDES', LATSCHEN: 'SLIDES', SLIDES: 'SLIDES',
        SLIPPER: 'SLIDES', SCHLAPPEN: 'SLIDES' },
      HEAD: { CAP: 'CAP', HAT: 'HAT', HUT: 'HAT', MUETZE: 'BEANIE', BEANIE: 'BEANIE' },
      ACC: { SONNENBRILLE: 'GLASSES', BACKPACK: 'BAG', BAG: 'BAG', POUCH: 'BAG', TURNBEUTEL: 'BAG',
        BAUCHTASCHE: 'BAG', BOTTLE: 'BOTTLE', TOWEL: 'TOWEL', HANDTUCH: 'TOWEL', RUCKSACK: 'BAG', TASCHE: 'BAG',
        SHAKER: 'BOTTLE', FLASCHE: 'BOTTLE' },
      GEAR: { GUERTEL: 'BELT', GRIPS: 'GRIPS', KNIEBANDAGEN: 'KNEE', HANDSCHUH: 'GLOVES' },
      EXCLUDE: { PIN: 'X', ANSTECKPIN: 'X', DUFTBAUM: 'X', GUTSCHEIN: 'X', GESCHENKKARTE: 'X', GIFTCARD: 'X', RIECHSALZ: 'X', DUFT: 'X' }
    },
    // Signalwörter Damen (alternativ Tag "damen")
    female: ['BRA', 'LEGGINGS', 'LEGGING', 'CROP', 'BIKINI', 'FIGURE', 'WELLNESS', 'FITMODEL', 'BODYSUIT',
      'SHAPEWEAR', 'SCRUNCH', 'JUMPSUIT'],
    femaleTags: ['damen', 'frauen', 'women', 'woman', 'female'],
    maleTags: ['herren', 'maenner', 'männer', 'men', 'male']
  };

  // Slot-Reihenfolge je Kategorie des aktuellen Produkts
  var SLOTS = {
    TOP: ['BOTTOM', 'LAYER', 'FOOT', 'HEAD'],
    LAYER: ['BOTTOM', 'TOP', 'FOOT', 'HEAD'],
    BOTTOM: ['TOP', 'LAYER', 'FOOT', 'HEAD'],
    WTOP: ['BOTTOM', 'LAYER', 'TOP', 'FOOT'],
    ONEPIECE: ['LAYER', 'HEAD', 'FOOT'],
    FOOT: ['FOOT', 'BOTTOM', 'TOP', 'HEAD'],
    HEAD: ['TOP', 'BOTTOM', 'LAYER', 'FOOT'],
    ACC: ['TOP', 'BOTTOM', 'HEAD', 'FOOT'],
    GEAR: ['GEAR', 'TANK', 'BOTTOM', 'TOP']
  };
  function slotsFor(cur) {
    if (cur.cat === 'BOTTOM' && (cur.sub === 'JOGGER' || cur.sub === 'PANTS')) return ['LAYER', 'TOP', 'FOOT', 'HEAD'];
    return SLOTS[cur.cat] || SLOTS.TOP;
  }
  // Kategorien, in denen ein zweites Teil derselben Kategorie erlaubt ist (wenn Subtyp anders)
  var SAME_CAT_OK = { FOOT: 1, GEAR: 1, ACC: 1 };

  var SLOT_LABEL = { TOP: 'Oberteil', LAYER: 'Layer', BOTTOM: 'Unterteil', WTOP: 'Top', ONEPIECE: 'Einteiler',
    FOOT: 'Socken & Schuhe', HEAD: 'Cap', ACC: 'Accessoire', GEAR: 'Equipment', TANK: 'Tank' };

  var POINTS = {
    sameLine: 100, partialLineWord: 25, colorWord: 30, colorMax: 60, neutralColor: 10,
    slot: [40, 25, 10, 5], sizeMatch: 20, sizeMissing: -60, fewSizes: -40, pool: 40,
    threshold: 60, thresholdAcc: 25
  };

  function normalize(str) {
    return String(str || '')
      .toUpperCase()
      .replace(/Ä/g, 'AE').replace(/Ö/g, 'OE').replace(/Ü/g, 'UE').replace(/ß/g, 'SS')
      .replace(/\$/g, 'S').replace(/!/g, 'I').replace(/®|™/g, '')
      .replace(/[–—\-\/&+,.()|:"']/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }

  function inList(list, w) { return list.indexOf(w) !== -1; }

  function matchType(token) {
    for (var cat in DICT.types) {
      var map = DICT.types[cat];
      for (var key in map) {
        if (token === key) return { cat: cat, sub: map[key], key: key };
        if (key.length >= 5 && token.length > key.length && token.slice(-key.length) === key) {
          return { cat: cat, sub: map[key], key: key };
        }
      }
    }
    return null;
  }

  /**
   * Zerlegt einen Produkttitel in Linie, Typ, Farbe, Geschlecht.
   * @param {string} title
   * @param {string[]} [tags]
   */
  function parseTitle(title, tags) {
    var tokens = normalize(title).split(' ').filter(Boolean);
    var type = null, colors = [], strong = [], weak = [], female = false;
    tokens.forEach(function (t) {
      if (/^\d/.test(t)) return;                         // Zahlen (87, 2018, 1 8L, 3ER) raus
      if (inList(DICT.female, t)) female = true;
      var m = matchType(t);
      if (m) { if (!type) type = m; return; }
      if (inList(DICT.colors, t)) { colors.push(t); return; }
      if (inList(DICT.brand, t) || inList(DICT.filler, t)) return;
      if (inList(DICT.weak, t)) { weak.push(t); return; }
      if (t.length < 2) return;
      strong.push(t);
    });
    // Kein Typwort, aber OVERSIZE/SKULL im Titel = Shirt (z. B. "L!VE MASSIVE SAMURAI OVERSIZE black")
    if (!type && tokens.some(function (t) { return t === 'OVERSIZE' || t === 'OVERSIZED'; })) type = { cat: 'TOP', sub: 'SHIRT' };
    var lowerTags = (tags || []).map(function (x) { return String(x).toLowerCase(); });
    if (lowerTags.some(function (x) { return inList(DICT.femaleTags, x); })) female = true;
    var male = lowerTags.some(function (x) { return inList(DICT.maleTags, x); });
    return {
      cat: type ? type.cat : null,
      sub: type ? type.sub : null,
      colors: colors,
      line: strong.length ? strong : weak,
      lineIsWeak: !strong.length,
      female: female,
      male: male && !female
    };
  }

  function sameSet(a, b) {
    if (!a.length || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) === -1) return false;
    return true;
  }

  /** Größen-Option eines Produkts (aus /products/x.js oder products.json) */
  function sizeInfo(product) {
    var opts = product.options || [];
    var idx = -1;
    for (var i = 0; i < opts.length; i++) {
      var n = normalize(typeof opts[i] === 'string' ? opts[i] : opts[i].name);
      if (n === 'GROESSE' || n === 'SIZE' || n === 'GROSSE') { idx = i; break; }
    }
    var variants = product.variants || [];
    var oneSize = variants.length <= 1 || idx === -1;
    var avail = variants.filter(function (v) { return v.available; })
      .map(function (v) { return idx === -1 ? v.title : (v.options ? v.options[idx] : v['option' + (idx + 1)]); });
    return { idx: idx, oneSize: oneSize, available: avail, count: variants.length, multiOption: opts.length > 1 };
  }

  /**
   * Bewertet einen Kandidaten relativ zum aktuellen Produkt.
   * @returns {{score:number, slotIndex:number, reasons:string[]}|null}  null = ausgeschlossen
   */
  function scoreCandidate(cur, cand, ctx) {
    var c = cand.parsed;
    if (!cand.available) return null;
    if (cand.id === ctx.currentId) return null;
    if (!c.cat || c.cat === 'EXCLUDE') return null;
    if (c.female && !cur.female) return null;
    if (cur.female && c.male) return null;

    var slots = slotsFor(cur);
    var slotKey = c.cat;
    if (cur.cat === 'GEAR' && c.sub === 'TANK') slotKey = 'TANK';
    var slotIndex = slots.indexOf(slotKey);
    if (slotIndex === -1) return null;
    if (c.cat === cur.cat) {
      if (!SAME_CAT_OK[c.cat] || c.sub === cur.sub) return null;
    }

    var score = 0, reasons = [];
    var lineSame = !cur.lineIsWeak === !c.lineIsWeak && sameSet(cur.line, c.line);
    if (lineSame) { score += POINTS.sameLine; reasons.push('line'); }
    else {
      var shared = c.line.filter(function (w) { return cur.line.indexOf(w) !== -1 && !inList(DICT.weak, w); }).length;
      score += shared * POINTS.partialLineWord;
    }
    var colorHits = c.colors.filter(function (w) { return cur.colors.indexOf(w) !== -1; }).length;
    if (colorHits) { score += Math.min(colorHits * POINTS.colorWord, POINTS.colorMax); reasons.push('color'); }
    else if (c.colors.some(function (w) { return inList(DICT.neutralColors, w); })) score += POINTS.neutralColor;

    score += POINTS.slot[slotIndex] || 0;

    if (cand.sizes && !cand.sizes.oneSize) {
      if (ctx.size && (c.cat === 'TOP' || c.cat === 'LAYER' || c.cat === 'BOTTOM' || c.cat === 'WTOP' || c.cat === 'ONEPIECE')) {
        if (cand.sizes.available.indexOf(ctx.size) !== -1) score += POINTS.sizeMatch;
        else score += POINTS.sizeMissing;
      }
      if (cand.sizes.available.length < 2) score += POINTS.fewSizes;
    }
    var pooled = ctx.fromPool && ctx.fromPool[cand.id];
    if (pooled) score += POINTS.pool;

    return { score: score, slotKey: slotKey, slotIndex: slotIndex, reasons: reasons, pooled: !!pooled };
  }

  /**
   * Wählt 2–max Teile aus einer Kandidatenliste.
   * candidates: [{id, title, tags, available, sizes, ...}]
   * @returns {{picks:Array, source:string}}
   */
  function pickOutfit(current, candidates, opts) {
    opts = opts || {};
    var max = opts.max != null ? opts.max : 3, min = opts.min != null ? opts.min : 2;
    var cur = current.parsed || parseTitle(current.title, current.tags);
    if (!cur.cat || cur.cat === 'EXCLUDE') return { picks: [], reason: 'no-category' };

    // Accessoires/Equipment haben keine Größen-Evidenz -> niedrigere Schwelle
    var threshold = ['FOOT', 'HEAD', 'ACC', 'GEAR'].indexOf(cur.cat) !== -1 ? POINTS.thresholdAcc : POINTS.threshold;
    var seen = {}, scored = [];
    candidates.forEach(function (cand) {
      if (seen[cand.id]) return; seen[cand.id] = 1;
      cand.parsed = cand.parsed || parseTitle(cand.title, cand.tags);
      var r = scoreCandidate(cur, cand, { currentId: current.id, size: opts.size, fromPool: opts.pool });
      if (!r) return;
      if (!r.pooled && r.score < threshold) return;
      scored.push({ cand: cand, r: r });
    });
    scored.sort(function (a, b) { return b.r.score - a.r.score; });

    var slots = slotsFor(cur), picks = [], usedSlot = {}, usedSub = {};
    // Pass 1: ein Teil pro Slot, in Slot-Reihenfolge
    slots.forEach(function (slot) {
      if (picks.length >= max) return;
      for (var i = 0; i < scored.length; i++) {
        var s = scored[i];
        if (s.r.slotKey !== slot || s.used) continue;
        if (usedSub[s.cand.parsed.cat + ':' + s.cand.parsed.sub]) continue;
        s.used = true; usedSlot[slot] = 1; usedSub[s.cand.parsed.cat + ':' + s.cand.parsed.sub] = 1;
        picks.push(s); break;
      }
    });
    // Pass 2: mit den besten Restkandidaten auffüllen (anderer Subtyp)
    for (var j = 0; j < scored.length && picks.length < max; j++) {
      var t = scored[j];
      if (t.used) continue;
      var k = t.cand.parsed.cat + ':' + t.cand.parsed.sub;
      if (usedSub[k]) continue;
      t.used = true; usedSub[k] = 1; picks.push(t);
    }
    // Anzeige-Reihenfolge = Slot-Reihenfolge
    picks.sort(function (a, b) { return a.r.slotIndex - b.r.slotIndex || b.r.score - a.r.score; });
    if (picks.length < min) return { picks: [], reason: 'too-few' };
    return {
      picks: picks.map(function (p) {
        return { product: p.cand, score: p.r.score, slot: p.r.slotKey, slotLabel: SLOT_LABEL[p.r.slotKey],
          sameSet: p.r.reasons.indexOf('line') !== -1, pooled: p.r.pooled };
      }),
      reason: 'ok'
    };
  }

  /** Typisches Suchwort je Slot (abhängig vom aktuellen Produkt) */
  function slotKeyword(slot, cur) {
    switch (slot) {
      case 'BOTTOM': return cur.female ? 'LEGGINGS' : ((cur.sub === 'TANK' || cur.sub === 'SHIRT' || cur.sub === 'JERSEY' || cur.sub === 'HEMD') ? 'SHORTS' : 'JOGGER');
      case 'TOP': return cur.sub === 'SHORTS' ? 'TANK' : 'SHIRT';
      case 'TANK': return 'TANK';
      case 'LAYER': return cur.female ? 'JACKET' : 'HOODIE';
      case 'FOOT': return cur.sub === 'SOCKS' ? 'BADELATSCHEN' : 'SOCKEN';
      case 'HEAD': return 'CAP';
      case 'GEAR': return cur.sub === 'GRIPS' ? 'GUERTEL' : 'GRIPS';
      default: return null;
    }
  }

  /** Suchbegriffe für die Predictive Search (max. 5, dedupliziert) */
  function buildQueries(cur) {
    var q = [], slots = slotsFor(cur);
    var line = cur.line.join(' ');
    if (line && cur.colors.length) q.push(line + ' ' + cur.colors.join(' '));
    if (line) q.push(line);
    if (cur.line.length > 1) q.push(cur.line[0]);
    var kw1 = slotKeyword(slots[0], cur), kw2 = slotKeyword(slots[1], cur);
    if (kw1 && cur.colors.length) q.push(kw1 + ' ' + cur.colors[0]);
    if (kw1) q.push(kw1);
    if (kw2) q.push(kw2);
    var seen = {};
    return q.filter(function (x) { x = x.trim(); if (!x || seen[x]) return false; seen[x] = 1; return true; }).slice(0, 5);
  }

  /* ---- Zubehör-Rotation ---- */

  // Subtyp -> Rotationsgruppe
  var ACC_GROUP = { SOCKS: 'SOCKS', SLIDES: 'SLIDES', CAP: 'HEADWEAR', HAT: 'HEADWEAR', BEANIE: 'HEADWEAR',
    GLASSES: 'GLASSES', BAG: 'BAG', BOTTLE: 'BOTTLE', TOWEL: 'TOWEL', BELT: 'GEAR', GRIPS: 'GEAR', KNEE: 'GEAR',
    GLOVES: 'FIGHT' };
  // Gewicht je Gruppe (0/fehlend = nie). Box-Handschuhe nur bei Gym-Zubehör.
  var ACC_WEIGHTS = {
    apparel: { SOCKS: 2, HEADWEAR: 2, GLASSES: 2, BAG: 2, BOTTLE: 2, TOWEL: 2, SLIDES: 2, GEAR: 1 },
    gym: { BAG: 3, BOTTLE: 3, TOWEL: 3, GEAR: 3, SOCKS: 1, HEADWEAR: 1, GLASSES: 1, SLIDES: 1, FIGHT: 1 }
  };

  function isAccessory(p) { return !!p && ['FOOT', 'HEAD', 'ACC', 'GEAR'].indexOf(p.cat) !== -1; }
  function accGroup(p) { return p ? (ACC_GROUP[p.sub] || null) : null; }

  /** 'apparel' (Bekleidung), 'worn' (Cap, Socken, Schlappen, Sonnenbrille) oder 'gym' (Tasche, Flasche, Handtuch, Equipment) */
  function accFamily(cur) {
    if (cur.cat === 'FOOT' || cur.cat === 'HEAD' || cur.sub === 'GLASSES') return 'worn';
    if (cur.cat === 'ACC' || cur.cat === 'GEAR') return 'gym';
    return 'apparel';
  }

  /** Aufteilung Bekleidung/Zubehör: Bekleidung & getragenes Zubehör 1 Zubehör, Gym-Zubehör 2 */
  function composition(cur, total) {
    var fam = accFamily(cur);
    var acc = Math.min(fam === 'gym' ? 2 : 1, total);
    return { apparel: total - acc, accessory: acc, family: fam };
  }

  function lineMatch(cur, p) {
    return !!p.line.length && !cur.lineIsWeak === !p.lineIsWeak && sameSet(cur.line, p.line);
  }

  /** Deterministischer Zufall (Seed pro Besuch + Produkt): stabil beim Neuladen, variiert zwischen Besuchern/Produkten */
  function rng(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function hashStr(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function weightedPick(items, weightFn, rand) {
    var ws = items.map(function (x) { return Math.max(0, weightFn(x) || 0); });
    var sum = ws.reduce(function (a, b) { return a + b; }, 0);
    if (!sum) return items[Math.floor(rand() * items.length)];
    var r = rand() * sum;
    for (var i = 0; i < items.length; i++) { r -= ws[i]; if (r < 0) return items[i]; }
    return items[items.length - 1];
  }

  /**
   * Zubehör rotieren: erst eine Art (gewichtet), dann ein Produkt daraus.
   * Gleiche Linie > gleiche Farbe > neutral. Eigene Art des aktuellen Produkts und schon gezeigte Arten nie.
   * Kürzlich gezeigtes Zubehör (recentIds) nur, wenn es in der Art nichts anderes gibt.
   * Kürzlich gezeigte Arten (recentGroups) kommen seltener dran.
   * opts: { count, seed, excludeIds, excludeGroups, recentIds, recentGroups }
   */
  function pickAccessory(current, candidates, opts) {
    opts = opts || {};
    var cur = current.parsed || parseTitle(current.title, current.tags);
    var count = opts.count == null ? 1 : opts.count;
    var rand = rng(opts.seed == null ? 1 : opts.seed);
    var weights = ACC_WEIGHTS[accFamily(cur) === 'gym' ? 'gym' : 'apparel'];
    var exclIds = opts.excludeIds || [], recent = opts.recentIds || [], recentGroups = opts.recentGroups || [];
    var exclGroups = (opts.excludeGroups || []).slice();
    if (accGroup(cur)) exclGroups.push(accGroup(cur));
    var byGroup = {}, seen = {};
    candidates.forEach(function (cand) {
      if (!cand || seen[cand.id] || !cand.available || cand.id === current.id || exclIds.indexOf(cand.id) !== -1) return;
      seen[cand.id] = 1;
      var p = cand.parsed = cand.parsed || parseTitle(cand.title, cand.tags);
      if (!isAccessory(p) || (p.female && !cur.female) || (cur.female && p.male)) return;
      var g = accGroup(p);
      if (!g || !weights[g] || exclGroups.indexOf(g) !== -1) return;
      if (g === 'FIGHT' && cur.cat !== 'GEAR') return;   // Box-/MMA-Handschuhe nur zu Gym-Equipment
      (byGroup[g] = byGroup[g] || []).push(cand);
    });
    var picks = [];
    while (picks.length < count) {
      var groups = Object.keys(byGroup).sort();
      if (!groups.length) break;
      var g = weightedPick(groups, function (x) {
        var allSeen = byGroup[x].every(function (c) { return recent.indexOf(c.id) !== -1; });
        return weights[x] * (byGroup[x].some(function (c) { return lineMatch(cur, c.parsed); }) ? 2 : 1) *
          (recentGroups.indexOf(x) !== -1 ? 0.3 : 1) * (allSeen ? 0.05 : 1);
      }, rand);
      var fresh = byGroup[g].filter(function (c) { return recent.indexOf(c.id) === -1; });
      var item = weightedPick(fresh.length ? fresh : byGroup[g], function (c) {
        if (lineMatch(cur, c.parsed)) return 6;
        if (c.parsed.colors.some(function (w) { return cur.colors.indexOf(w) !== -1; })) return 3;
        return c.parsed.colors.some(function (w) { return inList(DICT.neutralColors, w); }) ? 2 : 1;
      }, rand);
      picks.push({ product: item, score: 0, slot: item.parsed.cat, slotLabel: SLOT_LABEL[item.parsed.cat],
        sameSet: lineMatch(cur, item.parsed), pooled: false, accessory: true, group: g });
      delete byGroup[g];
    }
    return picks;
  }

  /**
   * Komplettes Outfit: Bekleidung deterministisch (beste Treffer), Zubehör rotierend.
   * opts: { total, min, size, pool, seed, recentIds, recentGroups, taken: {count, accCount, accGroups[], cats[], subs[]} }
   */
  function composeOutfit(current, candidates, accessories, opts) {
    opts = opts || {};
    var cur = current.parsed = current.parsed || parseTitle(current.title, current.tags);
    if (!cur.cat || cur.cat === 'EXCLUDE') return { picks: [], reason: 'no-category' };
    var taken = opts.taken || { count: 0, accCount: 0, accGroups: [], cats: [], subs: [] };
    var total = opts.total == null ? 3 : opts.total;
    var min = opts.min == null ? 2 : opts.min;
    var comp = composition(cur, total + taken.count);
    var needAcc = Math.min(total, Math.max(0, comp.accessory - taken.accCount));
    var apparel = candidates.filter(function (p) {
      var pr = p.parsed = p.parsed || parseTitle(p.title, p.tags);
      if (isAccessory(pr) || taken.subs.indexOf(pr.cat + ':' + pr.sub) !== -1) return false;
      return taken.cats.indexOf(pr.cat) === -1;
    });
    var appOpts = { min: 0, size: opts.size, pool: opts.pool };
    // Pro Bekleidungs-Kategorie nur ein Teil (keine zwei Hosen / zwei Pullover), Rest füllt das Zubehör
    var onePerCat = function (picks) {
      var used = {};
      return picks.filter(function (x) { var c = x.product.parsed.cat; if (used[c]) return false; used[c] = 1; return true; });
    };
    var app = onePerCat(pickOutfit(current, apparel, Object.assign({}, appOpts, { max: total - needAcc })).picks);
    var acc = pickAccessory(current, (accessories || []).concat(candidates), {
      count: total - app.length, seed: opts.seed, recentIds: opts.recentIds, recentGroups: opts.recentGroups,
      excludeGroups: taken.accGroups,
      excludeIds: app.map(function (x) { return x.product.id; })
    });
    // Zu wenig Zubehör -> mit weiterer Bekleidung auffüllen
    if (app.length + acc.length < total) {
      app = onePerCat(pickOutfit(current, apparel, Object.assign({}, appOpts, { max: total - acc.length })).picks);
    }
    var picks = comp.family === 'gym' ? acc.concat(app) : app.concat(acc);
    if (picks.length < min) return { picks: [], reason: 'too-few' };
    return { picks: picks, reason: 'ok' };
  }

  var core = {
    DICT: DICT, SLOTS: SLOTS, slotsFor: slotsFor, POINTS: POINTS, SLOT_LABEL: SLOT_LABEL,
    normalize: normalize, parseTitle: parseTitle, sizeInfo: sizeInfo,
    scoreCandidate: scoreCandidate, pickOutfit: pickOutfit, buildQueries: buildQueries,
    ACC_GROUP: ACC_GROUP, ACC_WEIGHTS: ACC_WEIGHTS, isAccessory: isAccessory, accGroup: accGroup, accFamily: accFamily,
    composition: composition, pickAccessory: pickAccessory, composeOutfit: composeOutfit, hashStr: hashStr
  };

  if (typeof module !== 'undefined' && module.exports) { module.exports = core; return; }
  root.MSOutfitCore = core;

  /* =========================================================================
   * 2. FETCH
   * ======================================================================= */

  var CACHE_PREFIX = 'ms-outfit:v1:';

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status + ' ' + url); return r.json(); });
  }

  function predictive(q, root) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,product_type,variants.title,tag';
    return getJSON(url).then(function (d) {
      return ((d.resources && d.resources.results && d.resources.results.products) || []).map(function (p) {
        return { id: p.id, handle: p.handle, title: p.title, tags: p.tags || [], available: p.available,
          price: Math.round(parseFloat(p.price) * 100), url: p.url.split('?')[0], image: p.image };
      });
    }).catch(function () { return []; });
  }

  function poolProducts(handle, root) {
    if (!handle) return Promise.resolve([]);
    return getJSON(root + 'collections/' + handle + '/products.json?limit=50').then(function (d) {
      return (d.products || []).map(fromProductsJson);
    }).catch(function () { return []; });
  }

  function fromProductsJson(p) {
    var variants = (p.variants || []).map(function (v) {
      return { id: v.id, title: v.title, available: v.available, price: Math.round(parseFloat(v.price) * 100),
        compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null,
        options: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }) };
    });
    var prod = { id: p.id, handle: p.handle, title: p.title, tags: p.tags || [],
      available: variants.some(function (v) { return v.available; }),
      options: (p.options || []).map(function (o) { return o.name; }), variants: variants,
      url: '/products/' + p.handle, image: p.images && p.images[0] ? p.images[0].src : null,
      price: variants.length ? Math.min.apply(null, variants.map(function (v) { return v.price; })) : 0 };
    prod.sizes = sizeInfo(prod);
    prod.full = true;
    return prod;
  }

  function productJs(handle, root) {
    return getJSON(root + 'products/' + handle + '.js').then(function (p) {
      var prod = { id: p.id, handle: p.handle, title: p.title, tags: p.tags || [], available: p.available,
        options: (p.options || []).map(function (o) { return o.name || o; }),
        variants: (p.variants || []).map(function (v) {
          return { id: v.id, title: v.title, available: v.available, price: v.price,
            compare_at_price: v.compare_at_price, options: v.options };
        }),
        url: p.url || ('/products/' + p.handle), image: p.featured_image, price: p.price };
      prod.sizes = sizeInfo(prod);
      prod.full = true;
      return prod;
    }).catch(function () { return null; });
  }

  /* =========================================================================
   * 3. UI
   * ======================================================================= */

  function formatMoney(cents, format) {
    format = format || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_with_comma_separator': return withDots + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return withDots;
        case 'amount_no_decimals': return withCommas;
        default: return withCommas + '.' + parts[1];
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function track(name, params) {
    try { if (typeof root.gtag === 'function') root.gtag('event', name, params); } catch (e) { /* noop */ }
    try { (root.dataLayer = root.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) { /* noop */ }
  }

  /** Symmetry-Sections, die nach Add-to-Cart neu gerendert werden (wie product-form in main.js) */
  function cartSections() {
    return ['page-header', 'cart-drawer'].map(function (sel) { return document.querySelector(sel); })
      .filter(function (el) { return el && el.dataset.sectionId && typeof el.updateFromCartChange === 'function'; });
  }

  /**
   * Symmetry 7.4 (verifiziert in assets/main.js + assets/cart-drawer.js):
   * product-form schickt `sections` mit /cart/add, ruft updateFromCartChange() auf page-header + cart-drawer
   * und öffnet danach .js-cart-drawer (theme.settings.afterAddToCart === 'drawer').
   * Fallback ohne Section-HTML: 'on:cart:change' -> cart-form und Header-Zähler laden selbst nach.
   */
  function refreshCartDrawer(data) {
    var els = cartSections();
    var sections = (data && data.sections) || {};
    var merged = els.length && els.every(function (el) { return sections[el.dataset.sectionId]; });
    if (merged) els.forEach(function (el) { el.updateFromCartChange(sections[el.dataset.sectionId]); });
    else document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

    var mode = root.theme && root.theme.settings ? root.theme.settings.afterAddToCart : 'drawer';
    if (mode === 'page') { root.location.href = (root.theme.routes && root.theme.routes.cart) || '/cart'; return; }
    if (mode === 'notification') {
      var tpl = document.getElementById('AddedNotification');
      if (tpl && tpl.content.firstElementChild) {
        var note = tpl.content.firstElementChild.cloneNode(true);
        note.dataset.productTitle = (data && data.items && data.items[0] && data.items[0].product_title) || '';
        (document.querySelector('.pageheader--sticky') || document.body).appendChild(note);
        return;
      }
    }
    var drawer = document.querySelector('.js-cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
  }

  function Section(el) {
    this.el = el;
    var cfgEl = el.querySelector('script[data-ms-outfit-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    this.root = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    this.row = el.querySelector('[data-ms-outfit-row]');
    this.tpl = el.querySelector('template[data-ms-outfit-card]');
    this.totalEl = el.querySelector('[data-ms-outfit-total]');
    this.size = this.cfg.selectedSize || null;
    this.bind();
    this.watchMainForm();
    if (this.cfg.mode === 'auto') this.lazyRun();
    else this.afterRender('manual');
  }

  Section.prototype.lazyRun = function () {
    var self = this, started = false;
    var go = function () { if (started) return; started = true; if (io) io.disconnect(); self.run(); };
    var near = function () { var r = self.el.getBoundingClientRect(); return r.height > 0 && r.top < (root.innerHeight || 800) + 600; };
    var io = null;
    if ('IntersectionObserver' in root) {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) go();
      }, { rootMargin: '600px 0px' });
      io.observe(this.el);
    }
    // Fallback: nach dem Laden prüfen und beim ersten Scrollen (falls IO nicht feuert)
    var check = function () { if (near()) go(); };
    if (document.readyState === 'complete') setTimeout(check, 50); else root.addEventListener('load', check, { once: true });
    root.addEventListener('scroll', check, { passive: true, once: true });
    if (!io) go();
  };

  var CACHE_TTL = 15 * 60 * 1000;

  /** Aktuelles Produkt, einmal geparst */
  Section.prototype.current = function () {
    if (!this._cur) {
      var p = this.cfg.product;
      this._cur = { id: p.id, title: p.title, tags: p.tags, parsed: parseTitle(p.title, p.tags) };
    }
    return this._cur;
  };

  Section.prototype.dropCache = function () {
    try { sessionStorage.removeItem(CACHE_PREFIX + this.cfg.product.id); } catch (e) { /* noop */ }
  };

  Section.prototype.run = function () {
    var self = this;
    var cacheKey = CACHE_PREFIX + this.cfg.product.id;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null'); } catch (e) { /* noop */ }
    if (!(cached && cached.t > Date.now() - CACHE_TTL)) return this.compute(cacheKey);
    if (!cached.picks || !cached.picks.length) return this.render([], 'auto');
    // Gecachte Auswahl nur zeigen, wenn alle Teile noch lieferbar sind (mit frischen Größendaten).
    // Ist eins inzwischen ausverkauft -> neu berechnen, passender Ersatz rückt nach.
    Promise.all(cached.picks.map(function (pk) {
      return pk.product && pk.product.handle ? productJs(pk.product.handle, self.root) : Promise.resolve(null);
    })).then(function (fresh) {
      if (!fresh.every(function (p) { return p && p.available; })) { self.dropCache(); return self.compute(cacheKey); }
      fresh.forEach(function (p, i) { p.parsed = parseTitle(p.title, p.tags); cached.picks[i].product = p; });
      self.render(cached.picks, 'auto');
    });
  };

  /**
   * Kandidaten laden: Predictive Search + Fallback-Collection, Top-N mit vollen Variantendaten (/products/x.js).
   * @param {number[]} excludeIds  Produkte, die nicht in Frage kommen (z. B. schon angezeigt)
   * @param {number} topN          Anzahl Kandidaten, deren Varianten nachgeladen werden
   */
  Section.prototype.loadCandidates = function (excludeIds, topN) {
    var self = this, cfg = this.cfg, cur = this.current();
    var skip = (cfg.manualIds || []).concat(excludeIds || []);
    var reqs = buildQueries(cur.parsed).map(function (q) { return predictive(q, self.root); });
    reqs.push(poolProducts(cfg.accessoryCollection, self.root));
    reqs.push(poolProducts(cfg.fallbackCollection, self.root));
    return Promise.all(reqs).then(function (lists) {
      var pool = lists.pop(), poolIds = {};
      var accessories = lists.pop().filter(function (p) { return p.id !== cur.id && skip.indexOf(p.id) === -1; });
      pool.forEach(function (p) { poolIds[p.id] = 1; });
      var light = [].concat.apply([], lists).filter(function (p) {
        return p.available && p.id !== cur.id && skip.indexOf(p.id) === -1;
      });
      // Vorauswahl ohne Größen, dann Top-Kandidaten mit Varianten nachladen
      var pre = light.map(function (p) {
        var r = scoreCandidate(cur.parsed, { id: p.id, available: true, parsed: parseTitle(p.title, p.tags) },
          { currentId: cur.id, fromPool: {} });
        return { p: p, s: r ? r.score : -1 };
      }).filter(function (x) {
        if (x.s < POINTS.thresholdAcc) return false;
        // Zubehör liefert die Zubehör-Collection inkl. Varianten -> Plätze für Bekleidung freihalten
        return !(cfg.accessoryCollection && isAccessory(parseTitle(x.p.title, x.p.tags)));
      }).sort(function (a, b) { return b.s - a.s; })
        .slice(0, topN);
      return Promise.all(pre.map(function (x) { return productJs(x.p.handle, self.root); })).then(function (full) {
        return {
          candidates: full.filter(Boolean).concat(pool).filter(function (p) { return skip.indexOf(p.id) === -1; }),
          poolIds: poolIds,
          accessories: accessories
        };
      });
    });
  };

  /** Was die server-gerenderten (manuellen) Karten schon belegen */
  Section.prototype.manualTaken = function () {
    var t = { count: 0, accCount: 0, accGroups: [], cats: [], subs: [] };
    this.row.querySelectorAll('article[data-ms-outfit-card][data-source="manual"]').forEach(function (c) {
      var pr = parseTitle(c.dataset.title || '', []);
      t.count++;
      if (!pr.cat) return;
      if (isAccessory(pr)) { t.accCount++; if (accGroup(pr)) t.accGroups.push(accGroup(pr)); }
      t.cats.push(pr.cat); t.subs.push(pr.cat + ':' + pr.sub);
    });
    return t;
  };

  /** Seed pro Besuch + Produkt: gleiche Auswahl beim Neuladen, Abwechslung zwischen Besuchern und Produkten */
  Section.prototype.seed = function () {
    var salt;
    try {
      salt = sessionStorage.getItem('ms-outfit:salt');
      if (!salt) { salt = String(Math.random()).slice(2); sessionStorage.setItem('ms-outfit:salt', salt); }
    } catch (e) { salt = String(Math.random()).slice(2); }
    return hashStr(salt + ':' + this.cfg.product.id);
  };

  /** Zuletzt gezeigtes Zubehör (pro Besuch), damit nicht auf jeder Seite dieselben Socken kommen */
  Section.prototype.recent = function () {
    try { return JSON.parse(sessionStorage.getItem('ms-outfit:recent') || '[]'); } catch (e) { return []; }
  };
  Section.prototype.recentGroups = function () {
    try { return JSON.parse(sessionStorage.getItem('ms-outfit:recent-groups') || '[]'); } catch (e) { return []; }
  };
  Section.prototype.rememberAccessories = function (picks) {
    var acc = picks.filter(function (p) { return p.accessory; });
    if (!acc.length) return;
    var ids = acc.map(function (p) { return p.product.id; });
    var groups = acc.map(function (p) { return p.group; }).filter(Boolean);
    var list = this.recent().filter(function (id) { return ids.indexOf(id) === -1; }).concat(ids).slice(-8);
    var glist = this.recentGroups().filter(function (g) { return groups.indexOf(g) === -1; }).concat(groups).slice(-2);
    try {
      sessionStorage.setItem('ms-outfit:recent', JSON.stringify(list));
      sessionStorage.setItem('ms-outfit:recent-groups', JSON.stringify(glist));
    } catch (e) { /* noop */ }
  };

  Section.prototype.compute = function (cacheKey) {
    var self = this, cfg = this.cfg, cur = this.current();
    if (!cur.parsed.cat || cur.parsed.cat === 'EXCLUDE') return this.hide();
    var taken = this.manualTaken();
    this.loadCandidates([], 6).then(function (res) {
      var out = composeOutfit(cur, res.candidates, res.accessories, {
        total: cfg.max - (cfg.manualCount || 0), min: Math.max(0, 2 - (cfg.manualCount || 0)),
        size: self.size, pool: res.poolIds, seed: self.seed(), recentIds: self.recent(),
        recentGroups: self.recentGroups(), taken: taken
      });
      self.rememberAccessories(out.picks);
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), picks: out.picks })); } catch (e) { /* noop */ }
      self.render(out.picks, 'auto');
    }).catch(function (err) { if (root.console) console.warn('[ms-outfit]', err); self.hide(); });
  };

  Section.prototype.hide = function () {
    if ((this.cfg.manualCount || 0) >= 2) return this.afterRender('manual');
    this.el.hidden = true;
    this.el.closest('.shopify-section') && (this.el.closest('.shopify-section').style.display = 'none');
  };

  Section.prototype.render = function (picks, source) {
    var self = this;
    this.row.querySelectorAll('[data-ms-outfit-skeleton]').forEach(function (n) { n.remove(); });
    var total = (this.cfg.manualCount || 0) + picks.length;
    if (total < 2) return this.hide();
    picks.forEach(function (pk) { self.row.appendChild(self.buildCard(pk)); });
    this.el.classList.add('is-ready');
    this.afterRender(source);
  };

  Section.prototype.buildCard = function (pk) {
    var p = pk.product, cfg = this.cfg;
    var frag = this.tpl.content.cloneNode(true);
    var card = frag.querySelector('[data-ms-outfit-card]');
    var pre = this.preselect(p);
    card.dataset.productId = p.id;
    card.dataset.handle = p.handle || '';
    card.dataset.source = 'auto';
    card.dataset.cat = pk.product.parsed ? pk.product.parsed.cat : '';
    card.dataset.sub = pk.product.parsed ? pk.product.parsed.sub : '';
    frag.querySelectorAll('[data-href]').forEach(function (a) { a.href = p.url; });
    var img = frag.querySelector('[data-img]');
    img.src = imgUrl(p.image, 600);
    img.srcset = [300, 450, 600].map(function (w) { return imgUrl(p.image, w) + ' ' + w + 'w'; }).join(', ');
    img.alt = p.title;
    frag.querySelector('[data-title]').textContent = p.title;
    var badge = frag.querySelector('[data-badge]');
    if (pk.sameSet && cfg.badgeText) { badge.textContent = cfg.badgeText; badge.hidden = false; }
    var v = this.variantFor(p, pre) || p.variants.filter(function (x) { return x.available; })[0];
    this.setPrice(frag.querySelector('[data-price]'), v);
    var opts = frag.querySelector('[data-opts]');
    if (p.sizes.multiOption) {
      opts.innerHTML = '<a class="ms-outfit__more" href="' + esc(p.url) + '">' + esc(cfg.i18n.chooseOptions) + '</a>';
    } else if (p.sizes.oneSize) {
      opts.innerHTML = '<div class="ms-outfit__onesize">' + esc(cfg.i18n.oneSize) + '</div>';
    } else {
      opts.innerHTML = '<div class="ms-outfit__sizes" role="group" aria-label="' + esc(cfg.i18n.chooseSize) + '">' +
        p.variants.map(function (vv) {
          var s = vv.options[p.sizes.idx];
          return '<button type="button" class="ms-outfit__size" data-variant-id="' + vv.id + '" data-size="' + esc(s) + '"' +
            (vv.available ? '' : ' disabled aria-label="' + esc(s) + ' ' + esc(cfg.i18n.soldOut) + '"') +
            ' aria-pressed="' + (vv.available && s === pre ? 'true' : 'false') + '">' + esc(s) + '</button>';
        }).join('') + '</div>';
    }
    card.dataset.variantId = v && (p.sizes.oneSize || pre) ? v.id : '';
    card.dataset.price = v ? v.price : p.price;
    this.updateButton(card);
    if (pre && p.sizes && !p.sizes.oneSize && pre === this.size) {
      var b = card.querySelector('.ms-outfit__size[aria-pressed="true"]'); b && b.classList.add('is-synced');
    }
    card._product = p;
    return frag;
  };

  Section.prototype.preselect = function (p) {
    if (!p.sizes || p.sizes.oneSize) return null;
    if (p.sizes.available.length === 1) return p.sizes.available[0];
    var cat = p.parsed ? p.parsed.cat : null;
    var apparel = ['TOP', 'LAYER', 'BOTTOM', 'WTOP', 'ONEPIECE'].indexOf(cat) !== -1;
    if (this.cfg.sizeSync && apparel && this.size && p.sizes.available.indexOf(this.size) !== -1) return this.size;
    return null;
  };

  Section.prototype.variantFor = function (p, size) {
    if (!size) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].options[p.sizes.idx] === size && p.variants[i].available) return p.variants[i];
    }
    return null;
  };

  Section.prototype.setPrice = function (el, v) {
    if (!el || !v) return;
    var f = this.cfg.moneyFormat;
    el.innerHTML = v.compare_at_price && v.compare_at_price > v.price
      ? '<span class="ms-outfit__sale">' + formatMoney(v.price, f) + '</span> <s>' + formatMoney(v.compare_at_price, f) + '</s>'
      : formatMoney(v.price, f);
  };

  Section.prototype.updateButton = function (card) {
    var btn = card.querySelector('[data-atc]');
    if (!btn) return;
    var ready = !!card.dataset.variantId;
    btn.disabled = !ready;
    btn.textContent = ready ? this.cfg.i18n.addToCart : this.cfg.i18n.chooseSize;
    btn.classList.remove('is-done');
  };

  Section.prototype.updateTotal = function () {
    if (!this.totalEl) return;
    var sum = this.cfg.product.price || 0;
    this.row.querySelectorAll('article[data-ms-outfit-card]').forEach(function (c) { sum += parseInt(c.dataset.price || '0', 10); });
    this.totalEl.textContent = formatMoney(sum, this.cfg.moneyFormat);
    var n = this.row.querySelectorAll('article[data-ms-outfit-card]').length + 1;
    var cnt = this.el.querySelector('[data-ms-outfit-count]');
    if (cnt) cnt.textContent = n;
  };

  /** Server-gerenderte (manuelle) Karten: Kategorie + "Gleiches Set" aus dem Titel ableiten, Größe synchronisieren */
  Section.prototype.decorateServerCards = function () {
    var self = this, curParsed = parseTitle(this.cfg.product.title, this.cfg.product.tags);
    this.row.querySelectorAll('article[data-ms-outfit-card][data-source="manual"]').forEach(function (card) {
      if (card._decorated) return; card._decorated = true;
      var parsed = parseTitle(card.dataset.title || '', []);
      card.dataset.cat = parsed.cat || '';
      card.dataset.sub = parsed.sub || '';
      var same = parsed.line.length && !parsed.lineIsWeak === !curParsed.lineIsWeak &&
        parsed.line.length === curParsed.line.length &&
        parsed.line.every(function (w) { return curParsed.line.indexOf(w) !== -1; });
      var badge = card.querySelector('[data-badge]');
      if (same && badge && self.cfg.badgeText) { badge.textContent = self.cfg.badgeText; badge.hidden = false; }
      if (self.cfg.sizeSync && self.size && !card.dataset.variantId) self.syncCard(card, self.size);
    });
  };

  Section.prototype.syncCard = function (card, size) {
    if (card.dataset.oneSize === 'true') return;
    if (card.dataset.cat && ['TOP', 'LAYER', 'BOTTOM', 'WTOP', 'ONEPIECE'].indexOf(card.dataset.cat) === -1) return;
    var btns = card.querySelectorAll('.ms-outfit__size');
    // Alten Sync-Ring entfernen: ist die neue Größe hier ausverkauft, bleibt die Auswahl, aber ohne "synchron"-Markierung
    for (var r = 0; r < btns.length; r++) btns[r].classList.remove('is-synced');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.size === size && !btns[i].disabled) { btns[i].click(); btns[i].classList.add('is-synced'); return; }
    }
  };

  Section.prototype.afterRender = function (source) {
    this.decorateServerCards();
    this.el.classList.add('is-ready');
    this.updateTotal();
    track('outfit_view', { product_id: this.cfg.product.id, quelle: source,
      items: this.row.querySelectorAll('article[data-ms-outfit-card]').length });
  };

  Section.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var sz = e.target.closest('.ms-outfit__size');
      if (sz && !sz.disabled) {
        var group = sz.parentElement;
        if (group.hasAttribute('data-main-sizes')) { self.selectMainSize(sz.dataset.size); return; }
        var card = sz.closest('[data-ms-outfit-card]');
        group.querySelectorAll('.ms-outfit__size').forEach(function (b) {
          b.setAttribute('aria-pressed', b === sz ? 'true' : 'false'); b.classList.remove('is-synced');
        });
        card.dataset.variantId = sz.dataset.variantId;
        if (sz.dataset.price) card.dataset.price = sz.dataset.price;
        else if (card._product) {
          var v = card._product.variants.filter(function (x) { return String(x.id) === sz.dataset.variantId; })[0];
          if (v) { card.dataset.price = v.price; self.setPrice(card.querySelector('[data-price]'), v); }
        }
        self.updateButton(card); self.updateTotal();
        return;
      }
      var btn = e.target.closest('[data-atc]');
      if (btn && !btn.disabled) self.add(btn.closest('[data-ms-outfit-card]'), btn);
    });
  };

  Section.prototype.add = function (card, btn) {
    var self = this, cfg = this.cfg;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var payload = { items: [{ id: parseInt(card.dataset.variantId, 10), quantity: 1, properties: { _quelle: 'outfit' } }] };
    var secIds = cartSections().map(function (el) { return el.dataset.sectionId; });
    if (secIds.length) { payload.sections = secIds.join(','); payload.sections_url = root.location.pathname; }
    fetch(this.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (data) {
        btn.textContent = cfg.i18n.added; btn.classList.add('is-done'); btn.removeAttribute('aria-busy');
        track('outfit_add_to_cart', { product_id: cfg.product.id, added_product_id: card.dataset.productId,
          variant_id: card.dataset.variantId, quelle: card.dataset.source || 'manual' });
        refreshCartDrawer(data);
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: parseInt(card.dataset.variantId, 10) } }));
        setTimeout(function () { self.updateButton(card); }, 2500);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        // Häufigster Grund: gerade ausverkauft -> Produkt frisch prüfen und ggf. sofort Ersatz nachziehen
        self.recheck(card).then(function (state) {
          if (state === 'replaced' || state === 'refreshed') return;
          btn.disabled = false;
          btn.textContent = (err && err.description) ? err.description : cfg.i18n.error;
          setTimeout(function () { self.updateButton(card); }, 3000);
        }).catch(function () { btn.disabled = false; self.updateButton(card); });
      });
  };

  /* ---- Ausverkauft während des Besuchs: Ersatz nachziehen ---- */

  /** Karte an gleicher Stelle durch eine frisch gebaute Karte ersetzen */
  Section.prototype.swapCard = function (oldCard, product, sameSet) {
    var frag = this.buildCard({ product: product, sameSet: !!sameSet });
    var card = frag.querySelector('[data-ms-outfit-card]');
    oldCard.parentNode.replaceChild(frag, oldCard);
    this.updateTotal();
    return card;
  };

  /**
   * Produkt einer Karte frisch prüfen.
   * Komplett ausverkauft -> passender Ersatz ('replaced'). Nur die gewählte Größe weg -> Karte mit
   * aktuellen Größen neu aufbauen ('refreshed'). Sonst 'ok' / 'unknown'.
   */
  Section.prototype.recheck = function (card) {
    var self = this, handle = card.dataset.handle;
    if (!handle) return Promise.resolve('unknown');
    return productJs(handle, this.root).then(function (p) {
      if (!p) return 'unknown';
      if (!p.available) return self.replaceCard(card).then(function () { return 'replaced'; });
      var vid = String(card.dataset.variantId || '');
      var v = p.variants.filter(function (x) { return String(x.id) === vid; })[0];
      if (!vid || (v && v.available)) return 'ok';
      p.parsed = parseTitle(p.title, p.tags);
      var badge = card.querySelector('[data-badge]');
      var fresh = self.swapCard(card, p, badge && !badge.hidden);
      fresh.dataset.source = card.dataset.source || 'auto';
      var b = fresh.querySelector('[data-atc]');
      if (b && !fresh.dataset.variantId) {
        b.textContent = self.cfg.i18n.sizeGone || 'Größe gerade ausverkauft';
        setTimeout(function () { self.updateButton(fresh); }, 3000);
      }
      self.dropCache();
      return 'refreshed';
    });
  };

  /** Bestes lieferbares Ersatzteil suchen: bevorzugt dieselbe Kategorie, sonst eine, die noch fehlt */
  Section.prototype.replaceCard = function (card) {
    var self = this, cur = this.current();
    var cards = [].slice.call(this.row.querySelectorAll('article[data-ms-outfit-card]'));
    var others = cards.filter(function (c) { return c !== card; });
    var excludeIds = cards.map(function (c) { return parseInt(c.dataset.productId, 10); });
    var shownCats = others.map(function (c) { return c.dataset.cat; });
    var shownSubs = others.map(function (c) { return c.dataset.cat + ':' + c.dataset.sub; });
    var lostCat = card.dataset.cat;
    var lostIsAcc = isAccessory({ cat: lostCat });
    var threshold = ['FOOT', 'HEAD', 'ACC', 'GEAR'].indexOf(cur.parsed.cat) !== -1 ? POINTS.thresholdAcc : POINTS.threshold;
    this.dropCache();
    var swapAccessory = function (res) {
      var otherGroups = others.map(function (c) { return accGroup({ sub: c.dataset.sub }); }).filter(Boolean);
      var acc = pickAccessory(cur, res.accessories.concat(res.candidates), {
        count: 1, seed: self.seed() + excludeIds.length, excludeIds: excludeIds, excludeGroups: otherGroups,
        recentIds: self.recent()
      })[0];
      if (!acc) return false;
      self.swapCard(card, acc.product, acc.sameSet);
      self.rememberAccessories([acc]);
      track('outfit_replace', { product_id: self.cfg.product.id, removed_product_id: card.dataset.productId,
        added_product_id: acc.product.id });
      return true;
    };
    return this.loadCandidates(excludeIds, 10).then(function (res) {
      if (lostIsAcc) { if (!swapAccessory(res)) self.removeCard(card); return; }
      var best = null;
      res.candidates.forEach(function (p) {
        if (excludeIds.indexOf(p.id) !== -1) return;
        p.parsed = p.parsed || parseTitle(p.title, p.tags);
        if (isAccessory(p.parsed)) return;
        if (shownSubs.indexOf(p.parsed.cat + ':' + p.parsed.sub) !== -1) return;
        var r = scoreCandidate(cur.parsed, p, { currentId: cur.id, size: self.size, fromPool: res.poolIds });
        if (!r || (!r.pooled && r.score < threshold)) return;
        var rank = p.parsed.cat === lostCat ? 0 : (shownCats.indexOf(p.parsed.cat) === -1 ? 1 : 2);
        if (rank === 2) return;
        if (!best || rank < best.rank || (rank === best.rank && r.score > best.r.score)) best = { p: p, r: r, rank: rank };
      });
      if (!best) { if (!swapAccessory(res)) self.removeCard(card); return; }
      self.swapCard(card, best.p, best.r.reasons.indexOf('line') !== -1);
      track('outfit_replace', { product_id: self.cfg.product.id, removed_product_id: card.dataset.productId,
        added_product_id: best.p.id });
    }).catch(function () { self.removeCard(card); });
  };

  /** Kein Ersatz gefunden: Karte entfernen, unter 2 Teilen die Section ausblenden */
  Section.prototype.removeCard = function (card) {
    if (card.parentNode) card.parentNode.removeChild(card);
    if (this.row.querySelectorAll('article[data-ms-outfit-card]').length < 2) {
      this.el.hidden = true;
      var wrap = this.el.closest('.shopify-section');
      if (wrap) wrap.style.display = 'none';
    } else {
      this.updateTotal();
    }
  };

  /* ---- Größen-Sync mit dem Hauptformular ---- */
  Section.prototype.watchMainForm = function () {
    var self = this;
    // Symmetry 7.4: Hauptformular = form.js-product-form[data-product-id]. Vorher im DOM steht das
    // Ratenzahlungs-Formular .js-instalments-form (ebenfalls /cart/add) -> generischer Selektor träfe das falsche.
    var form = document.querySelector(this.cfg.mainFormSelector ||
      'form.js-product-form[data-product-id="' + this.cfg.product.id + '"]') ||
      document.querySelector('form.js-product-form');
    if (!form || this.el.contains(form)) return;
    this.mainForm = form;
    // Größen-Radios liegen im <variant-picker> außerhalb des <form>
    var scope = form.closest('.js-product');
    this.mainPicker = scope ? scope.querySelector('variant-picker') : null;
    var read = function () {
      var input = form.querySelector('[name="id"]');
      if (!input) return;
      var size = (self.cfg.variantSizes || {})[input.value];
      if (size && size !== self.size) self.onMainSize(size);
    };
    // variant-picker.js setzt input[name=id].value und feuert 'change' (bubbles) im Formular
    form.addEventListener('change', function () { setTimeout(read, 0); });
    // ...und dispatcht 'on:variant:change' (bubbles) mit detail.variant -> auch Preis für die Gesamtsumme
    document.addEventListener('on:variant:change', function (e) {
      if (e.detail && e.detail.form && e.detail.form !== form) return;
      var v = e.detail && e.detail.variant;
      if (v && typeof v.price === 'number') self.onMainPrice(v.price);
      read();
    });
  };

  Section.prototype.selectMainSize = function (size) {
    var pickerScope = this.mainPicker || this.mainForm;
    if (pickerScope) {
      var inputs = pickerScope.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === size) {
          if (!inputs[i].checked) inputs[i].click();
          return;
        }
      }
      var sel = pickerScope.querySelectorAll('select');
      for (var j = 0; j < sel.length; j++) {
        for (var k = 0; k < sel[j].options.length; k++) {
          if (sel[j].options[k].value === size) {
            sel[j].value = size; sel[j].dispatchEvent(new Event('change', { bubbles: true })); return;
          }
        }
      }
    }
    this.onMainSize(size);
  };

  /** Preis des aktuellen Produkts (Variantenwechsel oben) -> Karte + Gesamtsumme */
  Section.prototype.onMainPrice = function (cents) {
    if (cents === this.cfg.product.price) return;
    this.cfg.product.price = cents;
    var el = this.el.querySelector('[data-current] .ms-outfit__price');
    if (el) el.textContent = formatMoney(cents, this.cfg.moneyFormat);
    this.updateTotal();
  };

  Section.prototype.onMainSize = function (size) {
    var self = this;
    this.size = size;
    this.el.querySelectorAll('[data-main-sizes] .ms-outfit__size').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.size === size ? 'true' : 'false');
    });
    var label = this.el.querySelector('[data-main-size-label]');
    if (label) label.textContent = size;
    if (!this.cfg.sizeSync) return;
    this.row.querySelectorAll('article[data-ms-outfit-card]').forEach(function (card) { self.syncCard(card, size); });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-ms-outfit]').forEach(function (el) {
      if (el._msOutfit) return;
      el._msOutfit = new Section(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  root.MSOutfit = { init: init, core: core };
})(typeof window !== 'undefined' ? window : this);
